module.exports = __webpack_public_path__ + "public/SiteIcons/gusetIconStep3.svg?61b17dd4";